/**
 * config.ts — typed, zod-validated environment config seam for apps/web.
 *
 * Rule: ALL import.meta.env accesses MUST go through this module.
 * Direct import.meta.env accesses elsewhere are a lint violation.
 *
 * Fail-fast: throws on startup if validation fails (missing/invalid vars).
 * Mirrors the apps/api env.ts pattern (zod safeParse + descriptive throw).
 */

import { z } from "zod";

const envSchema = z.object({
  // Vacío en dev (usa el proxy de Vite con rutas relativas, sin CORS).
  // En prod: URL absoluta del API (ej. https://informes-marco-api.onrender.com).
  VITE_API_URL: z.string().url().or(z.literal("")).default(""),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  const issues = parsed.error.issues.map((i) => `  - ${i.path.join(".")}: ${i.message}`).join("\n");
  throw new Error(`[config] Invalid environment variables:\n${issues}`);
}

export const config = {
  apiUrl: parsed.data.VITE_API_URL,
} as const;

export type Config = typeof config;
